import type { TFunction } from 'i18next';
import { OTHER_TUTORIAL_CATEGORY, type TutorialDetails } from 'api/tutorialsApi';
import { foldText } from 'utils/foldText';

export const megabytes = (bytes: number, language: string) =>
  new Intl.NumberFormat(language, { style: 'unit', unit: 'megabyte', maximumFractionDigits: 1 }).format(bytes / 1024 ** 2);

export const matchesSearch = ({ title, description }: TutorialDetails, query: string) => {
  const needle = foldText(query.trim());
  return foldText(title).includes(needle) || foldText(description).includes(needle);
};

export const tutorialCategoryLabel = (t: TFunction, key: string): string => {
  switch (key) {
    case 'users':
      return t('Users');
    case 'technicians':
      return t('Technicians');
    case 'issues':
      return t('Issues');
    case OTHER_TUTORIAL_CATEGORY:
      return t('Other');
    default:
      return key;
  }
};
